/** @format */

export interface LoyaltyBalance {
  accountTypeId?: number;
  currentPointBalance: number;
  error?: boolean;
  rewardAmount: number;
  pointsToNextReward?: number;
  currentRewardTier?: number;
  nextRewardTier?: number;
  currentInstantRewardTier?: number;
  currentInstantRewardPointsCost?: number;
}
